import React from 'react';
import { Toaster } from 'react-hot-toast';
import { Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import EmployeeDashboard from './pages/EmployeeDashboard';
import AdminDashboard from './pages/AdminDashboard';
import SuperuserDashboard from './pages/SuperuserDashboard';
import ProtectedRoute from "./routes/ProtectedRoute";
import Unauthorized from "./pages/Unauthorized";
import Layout from './pages/Layout';
import Navbar from './pages/Navbar';


function App() {
  return (
    <Layout>
    <Toaster position="top-center" reverseOrder={false} />
      <Routes>
      {/* {Public Route} */}
      <Route path="/login" element={<Login />} />
      <Route path="/unauthorized" element={<Unauthorized />} />

      {/* Protected Routes */}
      {/* Protected Routes with Navbar */}
        <Route
          path="/dashboard"
          element={
            <>
               <ProtectedRoute allowedRoles={["employee"]}>
                <EmployeeDashboard />
              </ProtectedRoute>
            </>
          }
        />
        <Route
          path="/admin-dashboard"
          element={
            <>
               <ProtectedRoute allowedRoles={["admin"]}>
                <AdminDashboard />
              </ProtectedRoute>
            </>
          }
        />
        <Route
          path="/superuser-dashboard"
          element={
            <>
               <ProtectedRoute allowedRoles={["superuser"]}>
                <SuperuserDashboard />
              </ProtectedRoute>
            </>
          }
        />
      {/* default route */}
      <Route path="*" element={<Login />} />
    </Routes>
    </Layout>
    
  );
}

export default App;
